import React from "react"

import RoleAdder from "../RoleAdder"
import { BudgetedRole, PhaseId } from "../types"

type Props = {
  phaseId: PhaseId
  phaseName: string
  unallocatedRoles: readonly BudgetedRole[]
  onAddRole: (phaseId: PhaseId, roleId: number) => void
  onShowAllRoles: (phaseId: PhaseId) => void
  className?: string
}

const PhaseRoleAdder: React.FC<Props> = (props) => {
  const {
    phaseId,
    phaseName,
    unallocatedRoles,
    onAddRole,
    onShowAllRoles,
    className,
  } = props

  const handleAddRole = (roleId: number) => {
    onAddRole(phaseId, roleId)
  }

  const handleShowAllRoles = () => {
    onShowAllRoles(phaseId)
  }

  return (
    <RoleAdder
      roles={unallocatedRoles as BudgetedRole[]}
      onAddRole={handleAddRole}
      onShowAllRoles={handleShowAllRoles}
      dataTestSuffix={phaseName}
      placeholder={`Add Role`}
      className={className}
    />
  )
}

export default PhaseRoleAdder
